import { render } from "./personalCenterChangePasswords.vue?vue&type=template&id=69829968&scoped=true"
import script from "./personalCenterChangePasswords.vue?vue&type=script&lang=js"
export * from "./personalCenterChangePasswords.vue?vue&type=script&lang=js"

import "../assets/css/jiaoshi/bootstrap-v3.3.7.min.css?vue&type=style&index=0&id=69829968&scoped=true&lang=css"
import "../assets/css/jiaoshi/common.css?vue&type=style&index=1&id=69829968&scoped=true&lang=css"
import "../assets/css/jiaoshi/common1.css?vue&type=style&index=2&id=69829968&scoped=true&lang=css"
import "../assets/css/jiaoshi/form.css?vue&type=style&index=3&id=69829968&scoped=true&lang=css"
import "../assets/css/jiaoshi/laydate.css?vue&type=style&index=4&id=69829968&scoped=true&lang=css"
import "../assets/css/jiaoshi/my-profile.css?vue&type=style&index=5&id=69829968&scoped=true&lang=css"
import "../assets/css/jiaoshi/header_v5.css?vue&type=style&index=6&id=69829968&scoped=true&lang=css"
import "../assets/css/jiaoshi/change-password.css?vue&type=style&index=7&id=69829968&scoped=true&lang=css"

import exportComponent from "G:\\chandao\\TransportationCollege-dev\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69829968"]])

export default __exports__